import { render, staticRenderFns } from "./Adviser.vue?vue&type=template&id=0f124199&scoped=true&"
import script from "./Adviser.vue?vue&type=script&lang=js&"
export * from "./Adviser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f124199",
  null
  
)

export default component.exports